export default {
  namespaced: true,
  state: {
    ShowMask: false
  },
  mutations: {
    setIsShowMask(state, value) {
      state.ShowMask = value
    }
  },
  getters: {
    isShowMask(state) {
      return state.ShowMask
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/limits.js